import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María L.',
  quote: 'Desde que apliqué el semáforo, dejé de estar nerviosa cada vez que me llegaba un mensaje. Mis hijos me ven más tranquila y volvimos a disfrutar los fines de semana.'
}, {
  name: 'Carlos R.',
  quote: 'Pensé que tenía que ceder en todo para evitar peleas. Este manual me enseñó a poner límites sin generar una guerra. Mi salud mental dio un giro de 180 grados.'
}, {
  name: 'Luciana P.',
  quote: 'El método BIFF es magia pura. Mi ex dejó de mandarme testamentos porque ya no le doy el combustible que buscaba. Literalmente me ayudo mucho.'
}];
export function Testimonials() {
  return <section className="bg-slate-50 py-24 px-6 border-y border-slate-200" data-id="element-230">
      <div className="max-w-5xl mx-auto" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-232">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-233">
            Lo que dicen quienes ya recuperaron su paz
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-234">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col" data-id="element-235">
              <div className="flex gap-1 mb-6" data-id="element-236">
                {[...Array(5)].map((_, index) => <Star key={index} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-237" />)}
              </div>
              <p className="text-slate-700 text-lg italic mb-6 flex-grow leading-relaxed" data-id="element-238">
                "{t.quote}"
              </p>
              <p className="font-bold text-slate-900" data-id="element-239">{t.name}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}